import * as React from 'react';

export const KeyCodes = {
    ENTER: 13,
}

export const keyIsEnter = (e: React.KeyboardEvent<any>) => {
    return e.keyCode === KeyCodes.ENTER;
}